import { z } from 'zod';

export const remittanceLineSchema = z.object({
  id: z.uuid(),
  remittanceID: z.uuid(),
  recordCode: z.string(),
  claimNumber: z.string(),
  serviceDate: z.string().nullable(),
  tariffCode: z.string().nullable(),
  prefix: z.number().int().nullable(),
  services: z.number().int().nullable(),
  feeSubmitted: z.string().or(z.number()).nullable(),
  amountAssessed: z.string().or(z.number()),
  lineType: z.string(),
  eobCodes: z.array(z.string()).nullable(),
  raw: z.string().nullable(),
  createdAt: z.coerce.date(),
  remittance: z
    .object({
      id: z.uuid(),
      filename: z.string(),
      siteID: z.uuid(),
      totalFeeAssessed: z.string().or(z.number()).nullable(),
      parsedAt: z.coerce.date(),
      createdAt: z.coerce.date(),
      incomeFilePath: z.string().nullable(),
      payorID: z.uuid().nullable().optional(),
    })
    .nullable()
    .optional(),
});
